import { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import {
  useAlert,
  useAppAutoLogin,
  useLearningHistory,
  useLoading,
  useUserInfo,
} from ".";
import { globalLoginAPI } from "../api/accountAPI";
import { diagnosisProposalSelAPI } from "../api/diagnosisAPI";
import { membersLearnersAPI } from "../api/entryExternal";
import { PROP, TYPE, URL } from "../constant";
import { setActor, mathpidLogAPICall } from "../redux/logData";
import {
  getAppId,
  getSubscribe,
  getUserAgent,
  // getUserAgent,
  getUserAgentArr,
  hideSplash,
  setUserViewCount,
} from "../utils/utilityEtc";
import useAmplitude from "./useAmplitude";
import { guestSelAndReg } from "../api/globalAPI";
import _ from "lodash";
import { isIOS } from "react-device-detect";
import http from "../http/http";
import { appsflyer, appsflyerEventName } from "../utils/appsflyer";
import { getGeoIPAPI } from "../api/commonAPI";
import { appAppsflyerEventCuidSetFunc } from "../utils/appEventFunc";
import useHackleInfo from "./useHackle";

export default function useGbAppLogin() {
  const history = useHistory();
  const logDispatch = useDispatch();

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [loginResult, setResult] = useState("");

  const [Alert, CodeAlert] = useAlert();
  const { setInfo } = useUserInfo();

  const { setLoading, clearLoading } = useLoading();
  const { setLearningHistoryInfo } = useLearningHistory();
  const { setAmplitudeLog } = useAmplitude();
  const { appGlobalAutoLoginAPICall, appAutoLoginRegAPICall } =
    useAppAutoLogin();
  const { info: hackleInfo, setHackleInfo } = useHackleInfo();

  let guestInfo = {
    learnerId: "",
    memberType: "GUEST",
  };

  const gbAppLogin = async (pw, email) => {
    setLoading({ isShowSpinner: true, spinnerType: "1" });

    try {
      let result,
        countryCd = null;
      let isPaymentCountry = false;
      let subScribe = {};

      const testCode = JSON.parse(localStorage.getItem("payment_test")) || null;
      if (testCode) {
        localStorage.setItem("locale", testCode.locale);
        localStorage.removeItem("payment_test");
      }

      const res = await getGeoIPAPI({
        // IP 주소 맵핑된 해당 국가코드 조회
        ipAddr: "",
      });

      countryCd = res?.country_cd;
      if (testCode) countryCd = testCode?.country_cd;
      isPaymentCountry = getCountryOfPayment(countryCd, i18n.language);

      // Play Store 조회
      if (isPaymentCountry && countryCd === TYPE.COUNTRY_CODE.KOREA) {
        subScribe =
          (await getSubscribe(
            isPaymentCountry ? TYPE.PAYMENT[countryCd].PRODUCT_ID : ""
          )) || {};

        /** 운영 KR 상품 업데이트 이전 앱 방어코드 START */

        // subScribe = JSON.parse('{"productId":"mathpid_subscription_year", "subscribing":"N", "price":"₩4,990", "currencyCode":"KRW"}');
        // subScribe = JSON.parse('{"productId":"", "subscribing":"N", "price":"", "currencyCode":""}');
        isPaymentCountry =
          TYPE.PAYMENT[countryCd]?.PRODUCT_ID === subScribe?.productId;

        if (!isPaymentCountry) {
          subScribe = {};
        }

        /** 운영 KR 상품 업데이트 이전 앱 방어코드 END */
      }

      if (pw && email) {
        const appId = getAppId();

        // 글로번 로그인
        result = await globalLoginAPI({
          appId,
          chnCd: TYPE.CHANNEL.GLOBAL01,
          emailAdrs: email,
          pw,
        });
        await localStorage.setItem("access.email", email);
      } else {
        result = await appGlobalAutoLoginAPICall();
      }

      if (!result) return;

      if (result.code === "S000000") {
        setInfo({ learnerId: null });
        let lrnMbrId = "";

        const { resp } = result;
        const { learner, sbsceMbrId, accessToken } = resp;

        if (testCode) resp.purchsYn = testCode?.purchsYn || resp.purchsYn;
        let subScriptionPurchsYn = _.isEqual(resp.purchsYn, "Y");

        const locale = localStorage.getItem("locale");
        i18n.changeLanguage(locale ? locale.toLocaleLowerCase() : "en");

        await localStorage.setItem("access.token", accessToken);
        await localStorage.setItem("mathpidLoginChk", "Y");

        await appAutoLoginRegAPICall(sbsceMbrId, TYPE.ENTRY_TYPE.GLOBAL01);

        if (learner.length > 1) {
          history.push({
            pathname: URL.ACCOUNT.LEARNER_CHOICE,
            state: {
              sbsceMbrId,
              email,
              learner,
            },
          });
        } else {
          if (learner && learner.length === 0) {
            Alert(`${t("api_error.msg062")}`);
          }

          lrnMbrId = learner[0].lrnMbrId;
          // 특정학습회원 조회
          const memberResp = await membersLearnersAPI(sbsceMbrId, lrnMbrId);
          const {
            brthmt,
            sxdnCd,
            mbrNm,
            mbrId,
            emailAdrs,
            item1,
            item2,
            item3,
            item4,
            rgtnDt,
          } = memberResp;

          let memberType =
            guestInfo.memberType === TYPE.GB_USER_TYPE.GUEST &&
            guestInfo.learnerId !== sbsceMbrId
              ? TYPE.GB_USER_TYPE.MEMBER
              : guestInfo.memberType;

          const diagnosisInfo = await diagnosisProposalSelAPI(lrnMbrId);

          if (diagnosisInfo) {
            const { dgnsRsltCnfmYn, dgnsYn, memberYn } = diagnosisInfo;
            setInfo({
              isMember: memberYn,
            });

            setLearningHistoryInfo({
              isCompleteAIDiagnosis: dgnsYn,
              isCheckAIDiagnosisResult: dgnsRsltCnfmYn,
            });
          }

          setAmplitudeLog({
            eventCategory: "account",
            eventName: "로그인 실행",
          });

          appsflyer({
            eventName: appsflyerEventName.af_login,
            eventParams: null,
          });

          setHackleInfo({
            viewPath: "MAIN_GAME_BANNER",
            isShowHackle: true, // isShowHackle 조건
          });

          /** TEST PAYMENT START */

          // const subscribing = "N"; // store 결제여부
          // countryCd = "KR"; // 국가코드
          // resp.purchsYn = "Y"; // 결제사용자 여부

          // subScribe = {
          //   ...subScribe,
          //   productId: TYPE.PAYMENT[countryCd]?.PRODUCT_ID || "",
          //   subscribing,
          //   price:
          //     countryCd === "KR"
          //       ? "₩15,000"
          //       : countryCd === "IN" || countryCd === "PH"
          //       ? "$3.99"
          //       : "",
          //   currencyCode: TYPE.PAYMENT[countryCd]?.COUNTRY_CODE || "",
          // };
          // subScriptionPurchsYn = _.isEqual(resp.purchsYn, "Y");
          // isPaymentCountry = getCountryOfPayment(countryCd, i18n.language);

          /** TEST PAYMENT END */

          // local, dev
          if (
            process.env.REACT_APP_ENV === "local" ||
            process.env.REACT_APP_ENV === "development"
          ) {
            console.log("### country code : ", countryCd);
            if (isPaymentCountry) Alert(`country : ${countryCd || ""}`);
          }

          setInfo({
            userId: sbsceMbrId,
            // cntrtNo: learner[0].cntrtNo,
            // learnerCode: learner[0].cstmrNo,
            userEmail: emailAdrs,
            locale: "KO",
            learnerId: mbrId,
            learnerBirth: brthmt,
            learnerSex: sxdnCd,
            learnerName: mbrNm,
            iconImage: PROP.SIDE_ICON[0],
            entryType: TYPE.ENTRY_TYPE.GLOBAL01,
            className: "gb",
            terms: item1,
            privacy: item2,
            adult: item3,
            marketing: item4,
            rgtnDt: rgtnDt,
            memberType,
            learner,
            storeProductID: subScribe?.productId || "", // 상품명
            storeProductCode: TYPE.PAYMENT[countryCd]?.PRODUCT_CODE || "", // 상품코드
            subscribing: subScribe?.subscribing || "N", // store 결제여부
            subScriptionPurchsYn, // 결제사용자 여부(store 결제여부와 상이함)
            isPaymentCountry, // 결제국가 여부
            countryCd, // 국가코드
          });

          appAppsflyerEventCuidSetFunc(sbsceMbrId);

          const userAgentArr = getUserAgentArr();
          // kinesis API 추가 (device info 전달)
          http.request({
            url: `${URL.API.KINESIS.PKGINFO}`,
            method: http.METHOD.POST,
            data: {
              lrnMbrId, // 학습자 ID
              pkg_info: userAgentArr[2], // 패키지 이름
              package_version: userAgentArr[3], // 패키지 버전
              device_name: userAgentArr[1], // 디바이스 정보
              // devicescncd : '', // 디바이스 유형
              chn_cd: userAgentArr[4], // 채널코드
              nation_cd: userAgentArr[5] && userAgentArr[5].split("_")[0], // 로케일 정보 중 국가코드
              lang_cd: i18n.language, // 로케일 정보 중 언어코드
              time_zone: userAgentArr[6], // 시간대 정보
              // rgtn_dt : '', // 등록일시
              // ip_addr : '', // IP정보
              currency: subScribe?.currencyCode, // 통화정보
            },
          });

          const isIntroductionView = localStorage.getItem("gb_introduction");

          if (!isIntroductionView || isIntroductionView === "N") {
            history.push(URL.INTRODUCTION, { prevPoint: "appLogin" });
            clearLoading();
          } else {
            // 결제국가, 미구독 인경우
            if (isPaymentCountry && !subScriptionPurchsYn) {
              setUserViewCount(URL.SELECT_LEARNING); // 화면 누적 접속 수 저장
            }

            history.push(URL.SELECT_LEARNING, { prevPoint: "appLogin" });
          }
          if (emailAdrs) localStorage.setItem("access.email", emailAdrs);
        }

        logDispatch(
          setActor({
            account: {
              homePage: TYPE.ENTRY_TYPE.GLOBAL01,
              name: lrnMbrId,
            },
            name: "",
            objectType: "Agent",
          })
        );

        setTimeout(() => {
          // 앱 최초 진입시 호출
          logDispatch(mathpidLogAPICall({
            verbId: 'focused',
            objectId: 'application',
            idName: getUserAgent('packageName'),
            idValue: getUserAgent('VERSION_NAME')
          }));
        }, 0);

        // logDispatch(setUserInfo({
        //   userType: 'USER',
        //   ssaid: await getAppId()
        // }))
      } else if (result.code === "S001008") {
        gbAppLogin(guestInfo.memberPw, guestInfo.emailAdrs);
        return;
      } else {
        if (result?.resp) {
          CodeAlert(result.resp);
        }
        setResult("fail");
      }
    } catch (error) {
      console.log("%c##### Error-handleLogin: ", "color: red", error);
    } finally {
      // clearLoading();
    }
  };

  const guestLogin = async () => {
    setLoading({ isShowSpinner: true, spinnerType: "1" });
    const appId = getAppId();
    if (!appId) {
      // clearLoading();
      return;
    }
    const token = localStorage.getItem("access.token");
    const resp = await guestSelAndReg({
      appId,
      langCd: "KO",
      chnCd: TYPE.CHANNEL.GLOBAL01,
    });

    // 게스트 유무 체크 결과가 없을 때
    if (!resp || !resp.memberType) {
      throw Error;
    }

    setInfo({
      memberType: resp.memberType,
      guestLearnerId: resp.mbrId,
    });

    guestInfo = {
      learnerId: resp.mbrId,
      memberType: resp.memberType,
      memberPw: resp.memberPw,
      emailAdrs: resp.emailAdrs,
    };

    if (token) {
      gbAppLogin();
    } else {
      gbAppLogin(resp.memberPw, resp.emailAdrs);
    }
    // clearLoading();
  };

  return { gbAppLogin, loginResult, guestLogin };
}

/**
 * 결제국가 여부 가져오기
 * 1. KR + KO + Android > true,
 * 2. IN,PH + EN + Android > true,
 */
const getCountryOfPayment = (countryCd, language) => {
  let isPaymentCountry = true;

  if (_.isEmpty(TYPE.PAYMENT[countryCd]) || isIOS) {
    return !isPaymentCountry;
  }

  switch (countryCd.toUpperCase()) {
    case TYPE.COUNTRY_CODE.KOREA:
      if (
        (process.env.REACT_APP_ENV === "local" ||
          process.env.REACT_APP_ENV === "development") &&
        language === "en"
      ) {
        // isPaymentCountry = false;
      }
      break;
    case TYPE.COUNTRY_CODE.INDIA:
      if (
        (process.env.REACT_APP_ENV === "local" ||
          process.env.REACT_APP_ENV === "development") &&
        language === "ko"
      ) {
        // isPaymentCountry = false;
      }
      break;
    case TYPE.COUNTRY_CODE.PHILIPPINES:
      if (
        (process.env.REACT_APP_ENV === "local" ||
          process.env.REACT_APP_ENV === "development") &&
        language === "ko"
      ) {
        // isPaymentCountry = false;
      }
      break;
  }

  return isPaymentCountry;
};
